export default __webpack_public_path__ + "static/hero-layer-2-4b16035b607d84f864de7c0d3e2c13dc.svg";